import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const StoryTitle = ({ story: { title } }) => title;

StoryTitle.propTypes = {
  story: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { [ownProps.id]: story } = state.entities.stories;
  return { story };
};

export default connect(mapStateToProps)(StoryTitle);
